(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  //customElements.define('sticky-header', StickyHeader);

  /* Start of header desktop main menu open/close js */

  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  });

/* End of header desktop main menu open/close js */


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    

  function handleClass(node, className, action = "add") {
    node.classList[action](className);
  }
  
  const accordions = document.querySelectorAll(".accordion");
  
  accordions.forEach(function (accordion) {
    const heading = accordion.querySelector("span");
    const accordionContentWrap = accordion.querySelector(
      ".accordion__content-wrap"
    );
    const originalHeight = accordionContentWrap.offsetHeight;
    accordionContentWrap.style.height = 0;
  
    let accordionActiveClass = "accordion__active";
  
    heading.addEventListener("click", function () {
      if (this.parentNode.classList.contains(accordionActiveClass)) {
        handleClass(this.parentNode, accordionActiveClass, "remove");
        accordionContentWrap.style.height = 0 + "px";
      } else {
        handleClass(this.parentNode, accordionActiveClass);
        accordionContentWrap.style.height = originalHeight + "px";
      }
    });
  });

  function Tabs() {
    var bindAll = function() {
      var menuElements = document.querySelectorAll('[data-tab]');
      for(var i = 0; i < menuElements.length ; i++) {
        menuElements[i].addEventListener('click', change, false);
      }
    }

    var clear = function() {
      var menuElements = document.querySelectorAll('[data-tab]');
      for(var i = 0; i < menuElements.length ; i++) {
        menuElements[i].classList.remove('active');
        var id = menuElements[i].getAttribute('data-tab');
        document.getElementById(id).classList.remove('active');
      }
    }

    var change = function(e) {
      clear();
      e.target.classList.add('active');
      var id = e.currentTarget.getAttribute('data-tab');
      document.getElementById(id).classList.add('active');
    }

    bindAll();
  }

  var connectTabs = new Tabs();

 window.onload = () => {
    var hash =  window.location.hash;
    var menuElements = document.querySelectorAll('[data-tab]');
      for(var i = 0; i < menuElements.length ; i++) {
        menuElements[i].classList.remove('active');
        var id = menuElements[i].getAttribute('data-tab');
        var newdata = "#"+id;
        if(hash == newdata)  {
          document.getElementById(id).classList.add('active');
        } else {
          document.getElementById(id).classList.remove('active');
        }
      }
      var sideElements = document.querySelectorAll('.account-left-sidebar ul li [data-tab]');
      for(var i = 0; i < sideElements.length ; i++) {
        
        sideElements[i].classList.remove('active');
        var sid = sideElements[i].getAttribute('data-tab');
        var snewdata = "#"+sid;
        if(hash == snewdata)  {
          sideElements[0].classList.remove('active');
          sideElements[i].classList.add('active');
          document.getElementById('myaccountdata').classList.remove('active');
        }else if(hash == "#myorderdata") {
          sideElements[0].classList.remove('active');
          document.getElementById('myaccountdata').classList.remove('active');
        }
        else {
          sideElements[0].classList.add('active');
          document.getElementById('myaccountdata').classList.add('active');
        } 
      }
    typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    

  function handleClass(node, className, action = "add") {
    node.classList[action](className);
  }
  
  const accordions = document.querySelectorAll(".accordion");
  
  accordions.forEach(function (accordion) {
    const heading = accordion.querySelector("span");
    const accordionContentWrap = accordion.querySelector(
      ".accordion__content-wrap"
    );
    const originalHeight = accordionContentWrap.offsetHeight;
    accordionContentWrap.style.height = 0;
  
    let accordionActiveClass = "accordion__active";
  
    heading.addEventListener("click", function () {
      if (this.parentNode.classList.contains(accordionActiveClass)) {
        handleClass(this.parentNode, accordionActiveClass, "remove");
        accordionContentWrap.style.height = 0 + "px";
      } else {
        handleClass(this.parentNode, accordionActiveClass);
        accordionContentWrap.style.height = originalHeight + "px";
      }
    });
  });

  function Tabs() {
    var bindAll = function() {
      var menuElements = document.querySelectorAll('[data-tab]');
      for(var i = 0; i < menuElements.length ; i++) {
        menuElements[i].addEventListener('click', change, false);
      }
    }

    var clear = function() {
      var menuElements = document.querySelectorAll('[data-tab]');
      for(var i = 0; i < menuElements.length ; i++) {
        menuElements[i].classList.remove('active');
        var id = menuElements[i].getAttribute('data-tab');
        document.getElementById(id).classList.remove('active');
      }
    }

    var change = function(e) {
      clear();
      e.target.classList.add('active');
      var id = e.currentTarget.getAttribute('data-tab');
      document.getElementById(id).classList.add('active');
    }

    bindAll();
  }

  var connectTabs = new Tabs();

  window.onload = () => {
    var hash =  window.location.hash;
    var menuElements = document.querySelectorAll('[data-tab]');
      for(var i = 0; i < menuElements.length ; i++) {
        menuElements[i].classList.remove('active');
        var id = menuElements[i].getAttribute('data-tab');
        var newdata = "#"+id;
        if(hash == newdata)  {
          document.getElementById(id).classList.add('active');
        } else {
          document.getElementById(id).classList.remove('active');
        }
      }
      var sideElements = document.querySelectorAll('.account-left-sidebar ul li [data-tab]');
      for(var i = 0; i < sideElements.length ; i++) {
        
        sideElements[i].classList.remove('active');
        var sid = sideElements[i].getAttribute('data-tab');
        var snewdata = "#"+sid;
        if(hash == snewdata)  {
          sideElements[ 0].classList.remove('active');
          sideElements[i].classList.add('active');
          document.getElementById('myaccountdata').classList.remove('active');
        }else if(hash == "#myorderdata") {
          sideElements[0].classList.remove('active');
          document.getElementById('myaccountdata').classList.remove('active');
        }
        else {
          sideElements[0].classList.add('active');
          document.getElementById('myaccountdata').classList.add('active');
        } 
      }
    typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }
  function eraseCookie(name) {   
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  const btnClick = document.getElementById("add-address");
  const btnClickMobile = document.getElementById("add-address-mobile");
  btnClick.addEventListener("click", function() {
      setCookie('formcookie','formdata',7);
  });

  btnClickMobile.addEventListener("click", function() {
      setCookie('formcookie','formdata',7);
  });

  window.addEventListener('load', function(event) {
    var x = getCookie('formcookie');
    if (x) {
      eraseCookie('formcookie');
      window.location.href="/account";
    }
    // cookie set on /account page to redirct back because of shopify functionality
    if (document.cookie.match(/^(.*;)?\s*addAddress\s*=\s*[^;]+(.*)?$/)) {
      eraseCookie('addAddress');
      window.location.href="/account";
    } 
  },true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) 
          return;
        
        observer.unobserve(this);

        fetch(this.dataset.url).then(response => response.text()).then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        }).catch(e => {
          console.error(e);
        });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
